import React from 'react';
import DesktopAdStructure, {IDesktopAdStructureProps} from './components/desktopAdStructure';
import {Else, If, Then} from 'react-if';
import MobileAdStructure, {IMobileAdStructureProps} from './components/mobileAdStructure';


interface IAdStructureProps extends Partial<IDesktopAdStructureProps>, Partial<IMobileAdStructureProps> {

}

const AdCardStructure = (props: IAdStructureProps) => (
  <If condition={props.gui.greaterThan.medium}>
    <Then>{() => <DesktopAdStructure {...props}/>}</Then>
    <Else>{() => <MobileAdStructure {...props} />}</Else>
  </If>
);

AdCardStructure.defaultProps = {
  displaySquare: null,
  cardTitle: null,
  specialDetails: null,
  specialDetails2: null,
  timeRemaining: 0,
  originalPrice: 0,
  additionalRows: null,

  hideControl: false,
  hideStatus: false,

  view: () => {
  },
  edit: () => {
  },
  delete: () => {
  },

  gui: {greaterThan: {}},
};
export default AdCardStructure;
